import { render, staticRenderFns } from "./index.vue?vue&type=template&id=eaa63d7a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=eaa63d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa63d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaa63d7a')) {
      api.createRecord('eaa63d7a', component.options)
    } else {
      api.reload('eaa63d7a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=eaa63d7a&scoped=true&", function () {
      api.rerender('eaa63d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/EditAttachments/index.vue"
export default component.exports